import { Root, configure, util } from 'protobufjs';
import Long from 'long';
import libJSON from '@tock/protos/dist/lib.json';

util.Long = Long;
configure();

const root = Root.fromJSON(libJSON);
export const protoLib = root.resolveAll();
